import { Font } from "@react-pdf/renderer";
import LohitTelugu from "../assets/fonts/Lohit-Telugu.ttf";
import LohitDevanagari from "../assets/fonts/Lohit-Devanagari.ttf";
import LohitTamil from "../assets/fonts/Lohit-Tamil.ttf";
import LohitBengali from "../assets/fonts/Lohit-Bengali.ttf";
import LohitGujarati from "../assets/fonts/Lohit-Gujarati.ttf";
import NotoSansKannada from "../assets/fonts/NotoSansKannada-Regular.ttf";
import NotoSansMalayalam from "../assets/fonts/NotoSansMalayalam-Regular.ttf";

// Roboto only carries Latin glyphs, so Indic text in an order (client name,
// brand name, address, target locations) comes out as garbage unless a font for
// that script sits in the PDF's fallback stack. @react-pdf picks per code point
// from the stack, so we only register/ship the scripts a document actually uses
// instead of pulling ~1MB of fonts into every English-only order.
const SCRIPT_FONTS = [
  { family: "W2N Telugu", src: LohitTelugu, range: /[\u0C00-\u0C7F]/ },
  { family: "W2N Devanagari", src: LohitDevanagari, range: /[\u0900-\u097F]/ },
  { family: "W2N Tamil", src: LohitTamil, range: /[\u0B80-\u0BFF]/ },
  { family: "W2N Kannada", src: NotoSansKannada, range: /[\u0C80-\u0CFF]/ },
  { family: "W2N Malayalam", src: NotoSansMalayalam, range: /[\u0D00-\u0D7F]/ },
  { family: "W2N Bengali", src: LohitBengali, range: /[\u0980-\u09FF]/ },
  { family: "W2N Gujarati", src: LohitGujarati, range: /[\u0A80-\u0AFF]/ },
];

const registered = new Set();

const registerScriptFont = ({ family, src }) => {
  if (registered.has(family)) return;
  Font.register({ family, fonts: [{ src, fontWeight: "normal" }] });
  registered.add(family);
};

const toText = (value) => {
  if (value === null || value === undefined) return "";
  return typeof value === "string" ? value : JSON.stringify(value);
};

/**
 * Build the fontFamily stack for a PDF page from the data it renders.
 * Set it on the page style; @react-pdf inherits fontFamily down to every Text.
 *
 * @param {...any} values anything rendered into the document (objects are scanned whole)
 * @returns {string[]} [base, ...fonts for the scripts present in the values]
 */
export const getPdfFontStack = (...values) => {
  const text = values.map(toText).join(" ");
  const stack = ["Roboto"];

  for (const font of SCRIPT_FONTS) {
    if (!font.range.test(text)) continue;
    registerScriptFont(font);
    stack.push(font.family);
  }

  return stack;
};

export default getPdfFontStack;
